/**
 * TODOs y reglas de dominio — Fase 2 backend (Gestión Despacho).
 * Documentación en código; sin implementación en Fase 1 mock.
 *
 * Dominios separados:
 * - Comprador / despacho comprador (licencia, catálogo distribuidor)
 * - Cliente operativo del despacho → colección futura `despacho_clients`
 * - Cliente fiscal / contribuyente Visor SAT → colección `clients` (sin mezclar)
 * - Usuario interno del despacho (dueño, supervisor, auxiliar) → workspace del comprador
 * - Usuario distribuidor/diseñador/platform → compradores y licencias, no operación interna
 */

export const DESPACHO_FASE2_TODOS = [
  "Invitación de auxiliares por correo; el auxiliar crea su propia contraseña",
  "Roles por workspace (dueño, supervisor, auxiliar) con permisos granulares",
  "Filtros obligatorios por owner_id / workspace_id / tenant_id en toda consulta",
  "Separación comprador vs cliente operativo vs cliente fiscal (sin reutilizar `clients` como maestro despacho)",
  "Relación opcional despacho_client.visor_client_id o vínculo por RFC explícito",
  "Prohibir contraseñas compartidas; el dueño no captura ni ve contraseñas de auxiliares",
  "Colección dedicada despacho_clients (no mezclar con clients del Visor SAT)",
  "Canal soporte BNT sin acceso al chat interno ni clientes operativos por defecto",
  "Auxiliar de un comprador no puede ver workspace, clientes, tareas ni chats de otro comprador",
  "Validar max_auxiliares al invitar o activar auxiliar; bloquear si se supera el límite de la licencia",
  "Mostrar contador auxiliares autorizados / activos / disponibles en UI de Auxiliares",
  "Permitir que diseñador/distribuidor ajuste max_auxiliares por comprador desde módulo platform (futuro)",
];

/** Campos sugeridos en licencia/comprador — Fase 2; sin implementación en Fase 1. */
export const DESPACHO_FASE2_LICENSE_FIELDS = [
  "max_auxiliares",
  "max_clientes_despacho",
  "despacho_plan",
  "despacho_enabled",
  "despacho_expires_at",
];

export const DESPACHO_DOMAIN_GLOSSARY = {
  comprador:
    "Quien compra o contrata la licencia (ej. Despacho Contable ABC). Dominio comercial/distribuidor.",
  clienteOperativo:
    "Cliente que el despacho comprador atiende (ej. Comercial López SA de CV). Colección futura despacho_clients.",
  clienteFiscal:
    "Contribuyente del Visor SAT (XML, CFDI, confrontas). Colección clients. Vínculo opcional con cliente operativo.",
  usuarioInterno:
    "Persona que trabaja en el despacho comprador (dueño, supervisor, auxiliar). No es comprador ni cliente.",
  usuarioDistribuidor:
    "Diseñador/distribuidor/platform. Administra compradores y licencias; define límites comerciales (ej. max_auxiliares).",
  auxiliaresAutorizados:
    "Usuarios internos que trabajan en el despacho; el cupo lo define la licencia del comprador (distinto de clientes operativos).",
};
